// extracted by mini-css-extract-plugin
export default {"option":"FXhs0DIg0dGAzuXt64d1Fw=="};